import { isFalse, isSkland } from "../helper";
export var defaultModifiers = [
    {
        enable: isSkland,
        modifiers: [
            {
                key: "ui_return",
                when: function (params) { return isFalse(params.header); },
                to: true,
            },
        ],
    },
];
export var defaultUserAgentModifiers = [
    {
        ua: "HgWebview",
        modifiers: [
            {
                key: "ui_header",
                to: false,
            },
            {
                key: "ctr_webview",
                to: 1,
            },
        ],
    },
];
